import { render, staticRenderFns } from "./StudentInfoCard.vue?vue&type=template&id=504e031f&scoped=true"
import script from "./StudentInfoCard.vue?vue&type=script&lang=js"
export * from "./StudentInfoCard.vue?vue&type=script&lang=js"
import style0 from "./StudentInfoCard.vue?vue&type=style&index=0&id=504e031f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e031f",
  null
  
)

export default component.exports